module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主播名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "remote": "",
      "remote-method": _vm.getAnchorList,
      "disabled": ""
    },
    on: {
      "change": _vm.handleAnchorChange
    },
    model: {
      value: (_vm.form.anchor_nickname),
      callback: function($$v) {
        _vm.$set(_vm.form, "anchor_nickname", $$v)
      },
      expression: "form.anchor_nickname"
    }
  }, _vm._l((_vm.anchorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.anchor_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "anchor_id", $$v)
      },
      expression: "form.anchor_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-left",
    attrs: {
      "label": "类型"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.typeSel
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "value": _vm.form.type,
      "border": ""
    }
  }, [_vm._v("普通视频")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "value": _vm.form.type,
      "border": ""
    }
  }, [_vm._v("短视频")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择直播分类"
    },
    on: {
      "change": _vm.handleCateChange
    },
    model: {
      value: (_vm.form.cate_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "cate_name", $$v)
      },
      expression: "form.cate_name"
    }
  }, _vm._l((_vm.category), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.cate_name,
        "size": "mini",
        "value": item.cate_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "remote": "",
      "remote-method": _vm.getDistributorList,
      "disabled": ""
    },
    on: {
      "change": _vm.handleDistibutorChange
    },
    model: {
      value: (_vm.form.distributor_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "distributor_name", $$v)
      },
      expression: "form.distributor_name"
    }
  }, _vm._l((_vm.distributorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.inca_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "inca_id", $$v)
      },
      expression: "form.inca_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播标题"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "直播标题"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播简介"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "直播简介"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主讲人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "张三"
    },
    model: {
      value: (_vm.form.speaker),
      callback: function($$v) {
        _vm.$set(_vm.form, "speaker", $$v)
      },
      expression: "form.speaker"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主讲人简介"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "XX专家"
    },
    model: {
      value: (_vm.form.speaker_desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "speaker_desc", $$v)
      },
      expression: "form.speaker_desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "0"
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "播放数（设定）"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "0"
    },
    model: {
      value: (_vm.form.online),
      callback: function($$v) {
        _vm.$set(_vm.form, "online", $$v)
      },
      expression: "form.online"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频简介"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "简介"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频详情"
    }
  }, [_c('vue-html5-editor', {
    ref: "editor",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "content": _vm.form.content,
      "height": 360
    },
    on: {
      "change": _vm.updateContent
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("图片\n                ")]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb,
      "isMost": true
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播开始时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.start_at),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_at", $$v)
      },
      expression: "form.start_at"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播间封面图片"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('cover_image')
      }
    }
  }, [(_vm.form.cover_image) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.cover_image
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频类型",
      "prop": "source_video_type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "视频类型"
    },
    on: {
      "change": _vm.handleVideoTypeChange
    },
    model: {
      value: (_vm.form.source_video_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "source_video_type", $$v)
      },
      expression: "form.source_video_type"
    }
  }, _vm._l((_vm.sourceVideoTypeOption), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.source_video_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "source_video_type", $$v)
      },
      expression: "form.source_video_type"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频回放"
    }
  }, [_c('videoPicker', {
    attrs: {
      "data": _vm.itemVideo
    },
    on: {
      "change": _vm.pickVideo
    }
  })], 1), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "是否允许录播"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_record),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_record", $$v)
      },
      expression: "form.is_record"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "店铺商品选品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖励规则（积分）"
    }
  }, [_vm._l((_vm.attr_values), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "view-flex view-flex-middle key-item"
    }, [_c('el-input', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "placeholder": "积分值/人"
      },
      model: {
        value: (item.attr_values),
        callback: function($$v) {
          _vm.$set(item, "attr_values", $$v)
        },
        expression: "item.attr_values"
      }
    }), _vm._v(" "), _c('el-select', {
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }, _vm._l((_vm.giftType), function(item, index) {
      return _c('el-option', {
        key: item.rule_type,
        attrs: {
          "label": item.text,
          "value": item.rule_type
        }
      })
    }), 1), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "placeholder": "时间/秒"
      },
      model: {
        value: (item.time),
        callback: function($$v) {
          _vm.$set(item, "time", $$v)
        },
        expression: "item.time"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-trash-alt1",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default",
      "size": "small"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加规则")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖励规则（优惠券）"
    }
  }, [_c('el-button', {
    staticClass: "iconfont icon-cog banner-button-uploader",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(" 设置优惠券")]), _vm._v(" "), _c('div', {
    staticClass: "promotion-card-list"
  }, _vm._l((_vm.coupons.checked), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('el-button', {
      staticClass: "banner-button-uploader",
      attrs: {
        "type": "default"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('i', {
      staticClass: "remove-btn el-icon-delete",
      on: {
        "click": function($event) {
          return _vm.removeChecked(index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('el-select', {
    model: {
      value: (_vm.coupon_type),
      callback: function($$v) {
        _vm.coupon_type = $$v
      },
      expression: "coupon_type"
    }
  }, _vm._l((_vm.giftType), function(item, index) {
    return _c('el-option', {
      key: item.rule_type,
      attrs: {
        "label": item.text,
        "value": item.rule_type
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "placeholder": "时间/秒"
    },
    model: {
      value: (_vm.coupon_time),
      callback: function($$v) {
        _vm.coupon_time = $$v
      },
      expression: "coupon_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖励规则（红包）"
    }
  }, [_vm._l((_vm.money_values), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "view-flex view-flex-middle key-item"
    }, [_c('el-input', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "placeholder": "总金额/元"
      },
      model: {
        value: (item.money_values),
        callback: function($$v) {
          _vm.$set(item, "money_values", $$v)
        },
        expression: "item.money_values"
      }
    }), _vm._v(" "), _c('el-select', {
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }, _vm._l((_vm.giftType), function(item, index) {
      return _c('el-option', {
        key: item.rule_type,
        attrs: {
          "label": item.text,
          "value": item.rule_type
        }
      })
    }), 1), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "placeholder": "时间/秒"
      },
      model: {
        value: (item.time),
        callback: function($$v) {
          _vm.$set(item, "time", $$v)
        },
        expression: "item.time"
      }
    }), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "placeholder": "总份额"
      },
      model: {
        value: (item.markrting),
        callback: function($$v) {
          _vm.$set(item, "markrting", $$v)
        },
        expression: "item.markrting"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-trash-alt1",
      on: {
        "click": function($event) {
          return _vm.removeMoney(index)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default",
      "size": "small"
    },
    on: {
      "click": _vm.addMoney
    }
  }, [_vm._v("添加规则")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "红包开始时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.end_at),
      callback: function($$v) {
        _vm.$set(_vm.form, "end_at", $$v)
      },
      expression: "form.end_at"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.cancelSubmit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitItemsActionConfirm
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择优惠券",
      "visible": _vm.coupons.dialog,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.coupons, "dialog", $event)
      },
      "open": _vm.onshowModal,
      "close": _vm.oncloseModal
    }
  }, [_c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.coupons.loading),
      expression: "coupons.loading"
    }],
    staticClass: "dialog-list clearfix"
  }, [_vm._l((_vm.coupons.list), function(item) {
    return [_c('li', {
      class: item.checked ? 'checked' : '',
      on: {
        "click": function($event) {
          return _vm.selectItems(item)
        }
      }
    }, [(item.checked) ? _c('i', {
      staticClass: "el-icon-check"
    }) : _vm._e(), _vm._v(" " + _vm._s(item.title))])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.coupons.page.currentPage,
      "page-size": _vm.coupons.page.pageSize,
      "total": _vm.coupons.page.total
    },
    on: {
      "current-change": _vm.changeCouponsPage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._l((_vm.coupons.temp), function(item, index) {
    return [_c('li', [_vm._v(_vm._s(item.title))])]
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelSelected
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitSelected
    }
  }, [_vm._v("确 定")])], 1)])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0627f9aa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0627f9aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/live/edit.vue
// module id = 2440
// module chunks = 0